module.exports = __webpack_public_path__ + "img/youtubeLogo.7c068d93.svg";